// extracted by mini-css-extract-plugin
export default {"root":"Popper_root__pEefZ"};